/* BEVANUP_MOBILE_SEARCH_JALA_V1 */
(() => {
  const install = () => {
    const menu = document.querySelector('.bevanup-mobile-menu');
    if (!menu || menu.dataset.bevanupJalaSearch === 'true') return;
    const input = menu.querySelector('input[type="search"]');
    const results = menu.querySelector('.bevanup-mobile-menu__results');
    if (!input || !results) return;
    menu.dataset.bevanupJalaSearch = 'true';
    const viewAll = document.createElement('a');
    viewAll.className = 'bevanup-mobile-menu__view-all';
    viewAll.textContent = 'SEE ALL RESULTS';
    viewAll.hidden = true;
    results.insertAdjacentElement('afterend', viewAll);
    let requestId = 0;
    let timer;
    let catalogPromise;
    const setState = (query, hasResults = false) => {
      menu.classList.toggle('is-jala-search-active', Boolean(query));
      viewAll.hidden = !hasResults;
      if (hasResults) viewAll.href = '/search?q=' + encodeURIComponent(query);
    };
    const money = (product) => {
      const raw = product.price ?? product.price_min ?? product.variants?.[0]?.price;
      const amount = Number(raw);
      return Number.isFinite(amount) ? new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(amount) : '';
    };
    const render = (products, query) => {
      results.replaceChildren();
      products.forEach((product) => {
        const link = document.createElement('a');
        link.href = '/products/' + product.handle;
        link.className = 'bevanup-mobile-menu__result';
        link.setAttribute('role', 'option');
        const imageUrl = product.images?.[0]?.src || product.featured_image || '';
        if (imageUrl) {
          const image = document.createElement('img');
          image.src = imageUrl;
          image.alt = product.title;
          image.width = 84;
          image.height = 99;
          link.append(image);
        }
        const copy = document.createElement('span');
        const title = document.createElement('strong');
        const price = document.createElement('small');
        title.textContent = product.title;
        price.textContent = money(product);
        copy.append(title, price);
        link.append(copy);
        results.append(link);
      });
      setState(query, products.length > 0);
    };
    const search = async () => {
      const query = input.value.trim();
      const current = ++requestId;
      results.replaceChildren();
      setState(query);
      if (!query) return;
      try {
        catalogPromise ||= fetch('/collections/all/products.json?limit=250', { headers: { Accept: 'application/json' } })
          .then((response) => response.ok ? response.json() : null)
          .then((payload) => payload?.products || []);
        const catalog = await catalogPromise;
        if (current !== requestId) return;
        const needle = query.toLocaleLowerCase();
        render(catalog.filter((product) => [product.title, product.product_type, ...(product.tags || [])].join(' ').toLocaleLowerCase().includes(needle)).slice(0, 4), query);
      } catch (_) {
        if (current === requestId) setState(query);
      }
    };
    input.addEventListener('input', (event) => {
      event.stopImmediatePropagation();
      window.clearTimeout(timer);
      setState(input.value.trim());
      timer = window.setTimeout(search, 120);
    }, true);
  };
  const observe = () => {
    install();
    new MutationObserver(install).observe(document.body, { childList: true });
    window.setTimeout(install, 250);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', observe, { once: true }); else observe();
})();
